import { ActionButton } from '@fluentui/react';
import DefaultTextView from '../../../common/views/DefaultTextView';
import { Utils } from '../../../common/views/Utils';
import { EmailModel } from '../../models/EmailModel';

export type EmailItemProps = {
    email: EmailModel;
    onEdit: (email: EmailModel) => void;
    onDelete: (email: EmailModel) => void;
}

export default function EmailItemView({ email, onEdit, onDelete }: EmailItemProps) {
    const width4 = Utils.getColumnWidth(4);
    const width6 = Utils.getColumnWidth(6);
    const width8 = Utils.getColumnWidth(8);

    const row1 = () => {
        return <div className="ms-Grid-row">
            <div className={width8 + " left"}>{email.address}</div>
            <div className={width4 + " right"}>{email.isPrimary && <>
                <DefaultTextView text="default" />
            </>}</div>
        </div>
    }

    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width6 + " left"}>
                <ActionButton
                    iconProps={{ iconName: "Edit" }}
                    onClick={() => onEdit(email)}
                >Edit</ActionButton>
            </div>

            <div className={width6 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "Delete" }}
                    onClick={() => onDelete(email)}
                >Delete</ActionButton>
            </div>
        </div>;
    }

    return <div className="ph-15">
        <div className="ms-Grid pt-10 default-border">
            <div className="pt-5 pb-15 ph-5">
                {row1()}
            </div>

            {actionRow()}
        </div>
    </div>;
}